const ACTION_REQUIRED_STATUSES = new Set([
  "actionrequired",
  "pendingdocs",
  "pending_docs",
  "pendingdoc",
]);

export const USER_STATUS_LABELS = {
  approved: "Approved",
  declined: "Declined",
  actionRequired: "Action Required",
  pending: "Pending",
  rejected: "Rejected",
  accepted: "Accepted",
};

/** Normalize API / legacy status values to the current platform enum. */
export function normalizeUserStatus(status) {
  const s = String(status ?? "").trim();
  if (!s) return s;
  if (ACTION_REQUIRED_STATUSES.has(s.toLowerCase())) {
    return "actionRequired";
  }
  return s;
}

export function userStatusLabel(status) {
  const normalized = normalizeUserStatus(status);
  if (!normalized) return "-";
  return USER_STATUS_LABELS[normalized] ?? normalized;
}

export function isUserActionRequired(user) {
  return normalizeUserStatus(user?.status) === "actionRequired";
}

/** @deprecated Use {@link isUserActionRequired} */
export function isWorkerActionRequired(user) {
  return isUserActionRequired(user);
}

export function isPortalUserActionRequired(role, user) {
  return (
    (role === "worker" || role === "client") && isUserActionRequired(user)
  );
}
